import React from 'react'
import CardItem from '../CardItem'

const ListView = (props) => {
  const {actions, currentUser, view, setActions, filters} = props

  return (
    <div className='row mx-2'>
      {actions.map((action, index) => (
        <CardItem
          key={index}
          action={action}
          currentUser={currentUser}
          setActions={setActions}
          view={view}
          filters={filters}
        />
      ))}
    </div>
  )
}

export default ListView
